import React from "react";

const ADO_Query = () => {
  return (
    <div className="tutorial-page">
      <h1>ADO Query</h1>
      <p>This is the ADO Query page content.</p>
    </div>
  );
};

export default ADO_Query;
